var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Monitorar"},[_c('button',{staticClass:"btn -clear -hasIcon",attrs:{"type":"button"},on:{"click":_vm.reportar}},[_c('icon',{staticClass:"-left",attrs:{"name":"bell","size":"large"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("Monitorar processo")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }